import {
  SET_VIEW_MODE_ACTION,
} from './actions.type';
import { SET_VIEW_MODE } from './mutations.type';

export default {
  [SET_VIEW_MODE_ACTION](context, mode) {
    context.commit(SET_VIEW_MODE, mode);
  },
};
